var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgError = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_83_1",
    "data-name": "Component 83 \\u2013 1",
    width: 514.531,
    height: 335.653,
    viewBox: "0 0 514.531 335.653",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(69.373 251.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M225.714,218.2H214.385l-6.071,21.245h12.167l-7.6,29.675,22.207-37.788H221.962Z",
    transform: "translate(-97.262 -218.196)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M162.278,237.357H150.949L144.878,258.6h12.167l-7.6,29.676,22.209-37.787H158.525Z",
    transform: "translate(-144.878 -203.814)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M362.375,236.715H351.044l-6.069,21.243H357.14l-7.6,29.677,22.207-37.787H358.62Z",
    transform: "translate(5.316 -204.296)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M249.269,226.191H234.824l-7.738,27.083H242.6l-9.683,37.831,28.311-48.172h-16.74Z",
    transform: "translate(-83.171 -212.195)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M271.6,218.2H260.27L254.2,239.441h12.165l-7.594,29.675,22.207-37.788H267.847Z",
    transform: "translate(-62.819 -218.196)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M295.154,226.191H280.71l-7.736,27.083h15.511L278.8,291.106l28.312-48.172H290.37Z",
    transform: "translate(-48.729 -212.195)",
    fill: "#fbb040"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M419.943,163.062a28.027,28.027,0,0,0-35.663-13.728,27.979,27.979,0,0,0-41.446-2.577,84.739,84.739,0,0,1,34.016,57.415h59.221a25.718,25.718,0,0,0-16.128-41.109Z",
    transform: "translate(73.082 -26.613)",
    fill: "#4bbfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M250.552,112.641a90.947,90.947,0,0,1,64.617,26.747,91.938,91.938,0,0,1,73.674,10.978c.079-1,.126-2,.126-3.015a37.641,37.641,0,0,0-31.462-37.127,41,41,0,0,0-52.173-20.083,40.99,40.99,0,0,0-72.547,19.237,40.93,40.93,0,0,0-29.594,16.494A91.453,91.453,0,0,1,250.552,112.641Z",
    transform: "translate(-31.733 -74.709)",
    fill: "#4bbfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M187.119,179.935A91.211,91.211,0,0,1,236,152.46a91.459,91.459,0,0,1,12.5-26.791,42.282,42.282,0,0,0-29.246.879,42.409,42.409,0,0,0-75.059,19.9,42.4,42.4,0,0,0-33.475,63.1H168.73A91.18,91.18,0,0,1,187.119,179.935Z",
    transform: "translate(-105.25 -47.784)",
    fill: "#4bbfe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(71.878 52.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M495.943,284.435a70.741,70.741,0,0,0-44.362-113.073,77.081,77.081,0,0,0-98.093-37.755,77.066,77.066,0,0,0-136.4,36.167,77.047,77.047,0,0,0-60.832,114.661Z",
    transform: "translate(-146.309 -104.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(103.512 70.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M235.057,170.908a13.522,13.522,0,1,1-13.523-13.522A13.522,13.522,0,0,1,235.057,170.908Z",
    transform: "translate(-203.504 -135.073)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M228,164.773a7.1,7.1,0,1,1-7.1-7.1A7.1,7.1,0,0,1,228,164.773Z",
    transform: "translate(-199.156 -134.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M205.438,159.065l38.314,24.79s6.087-27.947,5.184-27.947-13.747-11.269-26.819-11.269",
    transform: "translate(-205.438 -144.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(113.814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_518",
    "data-name": "Ellipse 518",
    cx: 13.523,
    cy: 13.523,
    r: 13.523,
    transform: "matrix(1, -0.026, 0.026, 1, 11.686, 22.672)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M278.873,164.773a7.1,7.1,0,1,0,7.1-7.1A7.1,7.1,0,0,0,278.873,164.773Z",
    transform: "translate(-264.131 -134.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M314.04,159.065l-38.314,24.79s-6.083-27.947-5.184-27.947,13.747-11.269,26.819-11.269",
    transform: "translate(-270.452 -144.64)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(58.847 57.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M276.808,199.355a1.954,1.954,0,0,1-1.95-1.955,15.949,15.949,0,0,0-31.9,0,1.954,1.954,0,1,1-3.907,0,19.854,19.854,0,0,1,39.709,0A1.953,1.953,0,0,1,276.808,199.355Z",
    transform: "translate(-239.053 -177.546)",
    fill: "#414042"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M510.734,191.214a70.758,70.758,0,0,0-2.906-20.078c-41.908,26.261-170.773,87.781-357.342.406a77.16,77.16,0,0,0,5.772,62.941H495.943A70.419,70.419,0,0,0,510.734,191.214Z",
    transform: "translate(-146.309 -54.637)",
    fill: "#414042",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(383.045 11.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M367.869,81.424a42.7,42.7,0,0,0-36.794,64.394l-7.018,20,17.884-7.753a42.708,42.708,0,1,0,25.928-76.645Z",
    transform: "translate(-324.057 -81.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Whoo_oops_",
    "data-name": "Whoo oops!",
    transform: "translate(14.533 37.493)",
    fill: "#4bbfe8",
    fontSize: 17,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Whoo"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "oops!")), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M367.869,159.157a42.7,42.7,0,0,0,34.776-67.489c-8.438,18.922-28.325,47.126-71.847,47.247l-6.742,19.218,17.884-7.753A42.527,42.527,0,0,0,367.869,159.157Z",
    transform: "translate(-324.057 -73.735)",
    fill: "#414042",
    opacity: 0.1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.2146a8bf.svg";
export { ForwardRef as ReactComponent };